import React, { Component } from 'react'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from 'primereact/button';
import classNames from 'classnames';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { CiteService } from '../../service/CiteService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { ParametrePaiementService } from '../../service/ParametrePaiementService';


export class ParametrePaiement extends Component {
    emptyParametrePaiement = {
        idParametrePaiement : 0,
        idCite : 0,
        nomCite : "",
        nbMoisOccupation : "",
        nbMoisCaution : "",
        nbMoisPremierVersement : "",
        nbEcheanceReste : ""
    };
    constructor() {
        super();
        this.state = {

            listeCite : [],
            listeParametre : [],
            listeCategorieChambre : [],
            parametrePaiementDialog: false,
            parametrePaiement: this.emptyParametrePaiement,
            submitted: false,
            loading : false,
            globalFilter: null
        }

        this.parametrePaiementService = new ParametrePaiementService();
        this.citeService = new CiteService();

        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.moisRestantBodyTemplate = this.moisRestantBodyTemplate.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.saveParametrePaiement = this.saveParametrePaiement.bind(this);
        this.editParametrePaiement = this.editParametrePaiement.bind(this);
        this.onChampChange = this.onChampChange.bind(this);
        this.loadDonnees = this.loadDonnees.bind(this);
    }
    componentDidMount() {
        this.loadDonnees();
    }

    loadDonnees() {
        this.setState({loading : true})
        this.citeService.getAll().then(data => {
            this.setState({listeCite: data, loading : false})
        })
        .catch(error => {
            this.notify2()
            console.log(error)
            this.setState({loading : false})
        })

        // tant que l'API de paramétrage n'est pas livrée, la liste reste vide
        // et toutes les cités s'affichent en "Non paramétré"
        this.parametrePaiementService.getAll().then(data => {
            this.setState({listeParametre : data})
        })
        .catch(error => {
            console.log(error)
            this.setState({listeParametre : []})
        })
    }

    /* Une ligne par cité : le paramétrage existant si présent, sinon des champs vides. */
    getLignes() {
        return this.state.listeCite.map(cite => {
            const parametre = this.state.listeParametre.find(p => p.idCite === cite.idCite);
            if (parametre) {
                return { ...parametre, idCite : cite.idCite, nomCite : cite.nomCite, parametre : true };
            }
            return { ...this.emptyParametrePaiement, idCite : cite.idCite, nomCite : cite.nomCite, parametre : false };
        });
    }

    getNbMoisRestant(parametrePaiement) {
        const occupation = parseInt(parametrePaiement.nbMoisOccupation);
        const premierVersement = parseInt(parametrePaiement.nbMoisPremierVersement);
        if (isNaN(occupation) || isNaN(premierVersement)) {
            return null;
        }
        return occupation - premierVersement;
    }

    hideDialog() {
        this.setState({
            submitted: false,
            parametrePaiementDialog: false
        });
    }
    editParametrePaiement(rowData) {
        this.setState({
            parametrePaiement : {
                idParametrePaiement : rowData.idParametrePaiement,
                idCite : rowData.idCite,
                nomCite : rowData.nomCite,
                nbMoisOccupation : rowData.nbMoisOccupation,
                nbMoisCaution : rowData.nbMoisCaution,
                nbMoisPremierVersement : rowData.nbMoisPremierVersement,
                nbEcheanceReste : rowData.nbEcheanceReste
            },
            listeCategorieChambre : [],
            submitted: false,
            parametrePaiementDialog: true
        });

        // les prix servent à montrer les montants qui découlent du paramétrage
        this.citeService.getCategorieChambre(rowData.idCite).then(data => {
            this.setState({listeCategorieChambre : data.listeCategorieChambre || []})
        })
        .catch(error => {
            console.log(error)
            this.setState({listeCategorieChambre : []})
        })
    }

    /* Renvoie un message d'erreur, ou null si le paramétrage est cohérent. */
    getErreurValidation() {
        const parametrePaiement = this.state.parametrePaiement;
        const occupation = parseInt(parametrePaiement.nbMoisOccupation);
        const caution = parseInt(parametrePaiement.nbMoisCaution);
        const premierVersement = parseInt(parametrePaiement.nbMoisPremierVersement);
        const echeance = parseInt(parametrePaiement.nbEcheanceReste);

        if (isNaN(occupation) || occupation < 1) {
            return "La durée d'occupation doit être d'au moins 1 mois.";
        }
        if (isNaN(caution)) {
            return "Le nombre de mois de caution est obligatoire.";
        }
        if (isNaN(premierVersement) || premierVersement < 1) {
            return "Le 1er versement doit couvrir au moins 1 mois de loyer.";
        }
        if (premierVersement > occupation) {
            return "Le 1er versement ne peut pas dépasser la durée d'occupation (" + occupation + " mois).";
        }
        const restant = occupation - premierVersement;
        if (restant === 0) {
            return null;
        }
        if (isNaN(echeance) || echeance < 1) {
            return "Le nombre d'échéances pour le reste est obligatoire.";
        }
        if (echeance > restant) {
            return "Le nombre d'échéances ne peut pas dépasser les " + restant + " mois restants.";
        }
        return null;
    }

    saveParametrePaiement() {
        if (this.getErreurValidation()) {
            this.setState({ submitted: true });
            return;
        }

        const parametrePaiement = this.state.parametrePaiement;
        const restant = this.getNbMoisRestant(parametrePaiement);
        const newParametrePaiement = {
            idParametrePaiement : parseInt(parametrePaiement.idParametrePaiement) ,
            idCite : parseInt(parametrePaiement.idCite) ,
            nbMoisOccupation : parseInt(parametrePaiement.nbMoisOccupation) ,
            nbMoisCaution : parseInt(parametrePaiement.nbMoisCaution) ,
            nbMoisPremierVersement : parseInt(parametrePaiement.nbMoisPremierVersement) ,
            nbEcheanceReste : restant === 0 ? 0 : parseInt(parametrePaiement.nbEcheanceReste)
        }
        console.log(newParametrePaiement)

        const requete = parametrePaiement.idParametrePaiement
            ? this.parametrePaiementService.update(parseInt(parametrePaiement.idParametrePaiement), newParametrePaiement)
            : this.parametrePaiementService.create(newParametrePaiement);

        requete.then(data => {
            this.notify();
            this.loadDonnees();
        })
        .catch(error => {
            this.notify2()
            console.log(error);
        })

        this.setState({
            submitted: true,
            parametrePaiementDialog: false,
            parametrePaiement: this.emptyParametrePaiement
        });
    }

    onChampChange(e, champ) {
        const val = (e.target && e.target.value) || '';
        // ces champs sont tous des nombres de mois / d'échéances
        if (val && !/^\d+$/.test(val)) {
            return;
        }
        this.setState({ parametrePaiement : { ...this.state.parametrePaiement, [champ] : val } });
    }

    moisRestantBodyTemplate(rowData) {
        if (!rowData.parametre) {
            return <span style={{color : "red"}}>Non paramétré</span>;
        }
        const restant = this.getNbMoisRestant(rowData);
        return <span>{restant} mois</span>;
    }
    moisBodyTemplate(rowData, champ, suffixe) {
        if (!rowData.parametre) {
            return <span>-</span>;
        }
        return <span>{rowData[champ]} {suffixe}</span>;
    }
    actionBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-pencil" className="p-button-warning" onClick={() => this.editParametrePaiement(rowData)} style={{marginRight: '.5em'}}/>
            </React.Fragment>
        );
    }
    notify = () => toast.success('Opération réuçit!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    notify2 = () => toast.error("Echec de l'opération !", {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )

    /* Montants qui découlent du paramétrage, pour chaque catégorie de chambre de la cité. */
    renderRecapitulatif() {
        const parametrePaiement = this.state.parametrePaiement;
        const restant = this.getNbMoisRestant(parametrePaiement);
        if (this.getErreurValidation() || restant === null) {
            return null;
        }
        const caution = parseInt(parametrePaiement.nbMoisCaution);
        const premierVersement = parseInt(parametrePaiement.nbMoisPremierVersement);
        const echeance = restant === 0 ? 0 : parseInt(parametrePaiement.nbEcheanceReste);

        const format = (valeur) => Number(valeur).toLocaleString('fr-FR') + " FCFA";

        return (
            <div className="p-field">
                <label>Montants correspondants</label>
                <table style={{width : "100%", fontSize : "0.85em", borderCollapse : "collapse"}}>
                    <thead>
                        <tr style={{borderBottom : "1px solid #ccc", textAlign : "left"}}>
                            <th>Catégorie</th>
                            <th style={{textAlign : "right"}}>1er versement</th>
                            <th style={{textAlign : "right"}}>Reste</th>
                            <th style={{textAlign : "right"}}>Par échéance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.listeCategorieChambre.map(categorie => {
                            const prix = parseInt(categorie.montantChambre);
                            if (isNaN(prix)) {
                                return (
                                    <tr key={categorie.idCategorieChambre}>
                                        <td>{categorie.libelleCategorieChambre}</td>
                                        <td colSpan="3" style={{textAlign : "right", color : "red"}}>prix non défini</td>
                                    </tr>
                                );
                            }
                            const totalReste = restant * prix;
                            return (
                                <tr key={categorie.idCategorieChambre}>
                                    <td>{categorie.libelleCategorieChambre}</td>
                                    <td style={{textAlign : "right"}}>{format((caution + premierVersement) * prix)}</td>
                                    <td style={{textAlign : "right"}}>{format(totalReste)}</td>
                                    <td style={{textAlign : "right"}}>{echeance ? format(Math.ceil(totalReste / echeance)) : "-"}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <small>1er versement = {caution} mois de caution + {premierVersement} mois de loyer.
                    {restant > 0
                        ? " Reste " + restant + " mois, en " + echeance + " échéance(s)."
                        : " Aucun reste à payer."}
                </small>
            </div>
        );
    }

    render() {
        const parametrePaiement = this.state.parametrePaiement;
        const restant = this.getNbMoisRestant(parametrePaiement);
        const erreur = this.getErreurValidation();
        let actionHeader = <Button type="button" icon="pi pi-cog"/>;
        const header = (
            <div className="table-header p-col-2">
                <span className="p-input-icon-left">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Recherche globale..." />
                </span>
            </div>
        );
        const parametrePaiementDialogFooter = (
            <React.Fragment>
                <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={this.hideDialog} />
                <Button label="Enregistrer" icon="pi pi-check" className="p-button-text" onClick={this.saveParametrePaiement} />
            </React.Fragment>
        );

        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="p-grid">
                        <div className="p-col-2">
                            <Button label="Rafraichir" icon="pi pi-refresh" className="" onClick={this.loadDonnees} />
                        </div>
                    </div>

                    <div className="card card-w-title datatable-demo">
                    <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <ToastContainer />
                        {header}
                        {this.state.loading ?
                        <div className="p-grid">
                            <div className="p-col-6" ></div>
                            <div className="p-col-6" >
                                {this.loadingSpinner("spin","black")}
                            </div>
                        </div>
                        :
                        <DataTable  ref={(el) => this.dt = el} value={this.getLignes()} selectionMode="single" header="Paiement du loyer par cité" paginator={true} rows={10}
                              globalFilter={this.state.globalFilter} filterMatchMode="contains" responsive={true} selection={this.state.dataTableSelection1} onSelectionChange={event => this.setState({dataTableSelection1: event.value})}>
                            <Column field="nomCite" header="Cité" filterMatchMode="contains" sortable={true} filter={true} filterPlaceholder="rechercher cité"/>
                            <Column field="nbMoisOccupation" header="Durée d'occupation" body={(rowData) => this.moisBodyTemplate(rowData, 'nbMoisOccupation', 'mois')} sortable={true}/>
                            <Column field="nbMoisCaution" header="Caution" body={(rowData) => this.moisBodyTemplate(rowData, 'nbMoisCaution', 'mois')} sortable={true}/>
                            <Column field="nbMoisPremierVersement" header="Loyer 1er versement" body={(rowData) => this.moisBodyTemplate(rowData, 'nbMoisPremierVersement', 'mois')} sortable={true}/>
                            <Column header="Reste à payer" body={this.moisRestantBodyTemplate}/>
                            <Column field="nbEcheanceReste" header="Échéances" body={(rowData) => this.moisBodyTemplate(rowData, 'nbEcheanceReste', '')} sortable={true}/>
                            <Column header={actionHeader} body={this.actionBodyTemplate} style={{textAlign:'center', width: '8em'}}/>
                        </DataTable>
                        }
                    </div>
                </div>

                <Dialog visible={this.state.parametrePaiementDialog} style={{ width: '550px' }} header="Paiement du loyer" modal className="p-fluid" footer={parametrePaiementDialogFooter} onHide={this.hideDialog}>
                    <div className="p-field">
                        <label htmlFor="nomCite">Cité</label>
                        <InputText id="nomCite" value={parametrePaiement.nomCite || ''} disabled />
                    </div>
                    <div className="p-field">
                        <label htmlFor="nbMoisOccupation">Durée d'occupation (mois)</label>
                        <InputText id="nbMoisOccupation" value={parametrePaiement.nbMoisOccupation} keyfilter="pint" onChange={(e) => this.onChampChange(e, 'nbMoisOccupation')} required autoFocus className={classNames({ 'p-invalid': this.state.submitted && !parametrePaiement.nbMoisOccupation })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="nbMoisCaution">Caution (nombre de mois de loyer)</label>
                        <InputText id="nbMoisCaution" value={parametrePaiement.nbMoisCaution} keyfilter="pint" onChange={(e) => this.onChampChange(e, 'nbMoisCaution')} required className={classNames({ 'p-invalid': this.state.submitted && !parametrePaiement.nbMoisCaution })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="nbMoisPremierVersement">Loyer payé au 1er versement (mois)</label>
                        <InputText id="nbMoisPremierVersement" value={parametrePaiement.nbMoisPremierVersement} keyfilter="pint" onChange={(e) => this.onChampChange(e, 'nbMoisPremierVersement')} required className={classNames({ 'p-invalid': this.state.submitted && !parametrePaiement.nbMoisPremierVersement })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="nbMoisRestant">Reste à payer (mois)</label>
                        <InputText id="nbMoisRestant" value={restant === null ? '' : restant} disabled />
                        <small>Calculé : durée d'occupation - loyer du 1er versement.</small>
                    </div>
                    <div className="p-field">
                        <label htmlFor="nbEcheanceReste">Nombre d'échéances pour le reste</label>
                        <InputText id="nbEcheanceReste" value={restant === 0 ? 0 : parametrePaiement.nbEcheanceReste} keyfilter="pint" disabled={restant === 0} onChange={(e) => this.onChampChange(e, 'nbEcheanceReste')} required className={classNames({ 'p-invalid': this.state.submitted && restant !== 0 && !parametrePaiement.nbEcheanceReste })} />
                    </div>
                    {this.state.submitted && erreur && <small className="p-invalid" style={{color : "red"}}>{erreur}</small>}
                    {this.renderRecapitulatif()}
                </Dialog>
            </div>
        )
    }
}

export default ParametrePaiement
